export default __webpack_public_path__ + "static/media/p23.822417b0.jpg";